/* eslint-disable no-prototype-builtins */
import React from 'react';
import {toast} from 'react-toastify';
import api from '../irelandApi';
import {
  GET_GROUPS_FETCHED,
  GET_GROUPS_PENDING,
  GET_GROUPS_REJECTED,
  GET_GROUP_FETCHED,
  GET_GROUP_PENDING,
  GET_GROUP_REJECTED,
  DELETE_GROUP_REJECTED,
  DELETE_GROUP_FETCHED,
  DELETE_GROUP_PENDING
} from '../reducers/groupsReducer';
import {history} from '../store';
import ToastMessage from '../components/common/toast-message';

const GROUPS_URL = '/api/admin/groups';
const INITIAL_PAGE = 1;
const DEFAULT_PER_PAGE = 10;

export const getGroups = (
  page = INITIAL_PAGE,
  name, dateFrom, dateTo,
  perPage = DEFAULT_PER_PAGE
) => (dispatch) => {
  dispatch({type: GET_GROUPS_PENDING});
  const q = {
    created_at_from: dateFrom,
    created_at_to: dateTo,
    name
  };
  return api.get(GROUPS_URL, {
    params: {
      page,
      per_page: perPage,
      q
    }
  })
    .then((response) => {
      dispatch({
        type: GET_GROUPS_FETCHED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_GROUPS_REJECTED,
        payLoad: error.response
      });
    });
};


export const getAllGroups = () => (dispatch) => {
  dispatch({type: GET_GROUPS_PENDING});
  return api.get(GROUPS_URL)
    .then((response) => {
      dispatch({
        type: GET_GROUPS_FETCHED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_GROUPS_REJECTED,
        payLoad: error.response
      });
    });
};

export const downloadGroups = () => api.get(`${GROUPS_URL}.csv`);

export const downloadGroup = id => api.get(`${GROUPS_URL}/${id}.csv`);

export const getGroup = id => (dispatch) => {
  dispatch({type: GET_GROUP_PENDING});
  return api.get(`${GROUPS_URL}/${id}`)
    .then((response) => {
      dispatch({
        type: GET_GROUP_FETCHED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_GROUP_REJECTED,
        payLoad: error.response
      });
    });
};

export const removeGroup = id => (dispatch) => {
  dispatch({type: DELETE_GROUP_PENDING});
  return api.delete(`${GROUPS_URL}/${id}`)
    .then(() => {
      dispatch({
        type: DELETE_GROUP_FETCHED,
        payLoad: id
      });
    })
    .catch((error) => {
      dispatch({
        type: DELETE_GROUP_REJECTED,
        payLoad: error.response
      });
    });
};

export const saveGroup = payLoad => api.post(GROUPS_URL, {group: payLoad})
  .then(() => {
    toast.success(<ToastMessage iconStyle="success" message="Group has been saved successfully"/>);
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="Error while saving group"/>);

    const errorData = error.hasOwnProperty('response') ? error.response.data.errors : [];

    return Promise.reject(errorData);
  });

export const updateGroup = (id, payLoad) => api.patch(`${GROUPS_URL}/${id}`, {group: payLoad})
  .then(() => {
    toast.success(<ToastMessage iconStyle="success" message="Group has been saved successfully"/>);
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="Error while saving group"/>);

    const errorData = error.hasOwnProperty('response') ? error.response.data.errors : [];

    return Promise.reject(errorData);
  })
  .then(() => {
    history.push('/admin/groups');
  });



// WEBPACK FOOTER //
// ./src/actions/groups.js